<script>
    import  { mapState,mapActions } from 'vuex';
    import PaymentPlansLayout1 from "../../../author/pagesbuilder/templates/cards/PaymentPlansLayout1";
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    export default {
        name: "PaymentOptionsComponent",
        mixins: [AnimationsMixin],
        data () {
            return {
                isPreview: false,
                componentType: "payment-plans",
                rendersWithVue: true
            }
        },
        computed: {
            ...mapState(['currencySymbol']),
            ...mapState('products',[
                'courses',
                'fetchingCourseContents',
            ]),
            hasShowDetailsOptions () {
                if ( (this.hasBundleOptions ||  this.hasSubscriptionOptions ) && ( this.getShowBundles || this.getShowSubscriptions ) ){
                    return true;
                }

                return false;
            },
            hasBundleOptions () {
                return this.renderData && this.renderData.bundles && this.renderData.bundles.length;
            },
            hasSubscriptionOptions () {
                return this.renderData && this.renderData.subscriptions && this.renderData.subscriptions.length;
            },
            hasPaymentPlanOptions () {
                return this.renderData && this.renderData.paymentPlans && this.renderData.paymentPlans.length;
            },
            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    template: 'PaymentPlansLayout1',
                    selectedCourseTitleId: "",
                    showDetails: true,
                    showBundles: true,
                    showSubscriptions: true,
                    showPaymentPlans: true,
                    itemVisibilitySettings: null
                }
            },
            getShowDetails () {
                return this.myData.showDetails;
            },
            getShowBundles () {
                return this.myData.showBundles;
            },
            getShowSubscriptions () {
                return this.myData.showSubscriptions;
            },
            getShowPaymentPlans () {
                return this.myData.showPaymentPlans;
            },
            myCourseData () {
                return this.courses.find(course => course.titleId === this.selectedCourseTitleId) || {};
            },
            selectedLayout () {
                return this.myData.template;
            },
            selectedCourseTitleId () {
                if (this.componentData.selectedCourseTitleId) {
                    return this.componentData.selectedCourseTitleId;
                }

                if (this.isPageContext('course') && this.pageContext.params && this.courses.filter( course => course.titleId === this.pageContext.params.slug).length ) {
                    return this.pageContext.params.slug;
                }

                return "";

            },
            renderData () {

                let selectedCourseTitleId = this.selectedCourseTitleId;

                if (selectedCourseTitleId && this.fetchingCourseContents.indexOf(selectedCourseTitleId) === -1 &&
                    ( !this.myCourseData || ( this.myCourseData && typeof this.myCourseData.sections === "undefined"))
                ) {
                    this.getCourseContents({courseId: selectedCourseTitleId, getParams: "author"});
                }

                let courseData = this.editCourseData(this.myCourseData);

                return {
                    ...courseData,
                    currencySymbol : this.currencySymbol,
                    showDetails: this.getShowDetails,
                    showBundles: this.getShowBundles,
                    showSubscriptions: this.getShowSubscriptions,
                    showPaymentPlans: this.getShowPaymentPlans,
                    optionsUseHref: this.optionsUseHref
                }
            },
        },
        methods: {
            ...mapActions('products',[
                'getCourseContents'
            ]),
            getSelectedCourse () {
                return this.selectedCourseTitleId;
            },
            paymentOptionSelected (data) {
                console.log('paymentOptionSelected', data)
            },
            editCourseData (course) {
                return course;
            },
            setShowDetails (eventData) {
                this.changeMyData({showDetails: eventData.value});
                this.setChangesAreSaved(false);
            },
            setShowBundles (eventData) {
                this.changeMyData({showBundles: eventData.value});
                this.setChangesAreSaved(false);
            },
            setShowSubscriptions (eventData) {
                this.changeMyData({showSubscriptions: eventData.value});
                this.setChangesAreSaved(false);
            },
            setShowPaymentPlans (eventData) {
                this.changeMyData({showPaymentPlans: eventData.value});
                this.setChangesAreSaved(false);
            },
        },
        components: {
            PaymentPlansLayout1
        }
    }
</script>
